/**
 * Resolve per-blank correct/incorrect for FITB review and feedback UI.
 */

import map from 'lodash/map';
import type { GradingResult } from '@ai-content-hub/content-kit';
import { buildFitbPerBlankCorrectness } from './grader';
import type { FITBAnswer, FITBElementData } from './schema';

function perBlankFromGradingResult(result?: GradingResult): Record<string, boolean> | undefined {
    const per = result?.details?.perBlank as { id: string; ok: boolean }[] | undefined;
    if (!per || per.length === 0) return undefined;
    const out: Record<string, boolean> = {};
    map(per, (p) => {
        out[p.id] = p.ok;
    });
    return out;
}

export function resolveFitbPerBlankOk(
    result: GradingResult | undefined,
    data: FITBElementData,
    answer: FITBAnswer,
    review: boolean,
): Record<string, boolean> | undefined {
    const fromResult = perBlankFromGradingResult(result);
    if (fromResult) return fromResult;
    if (review && (data.blanks?.length ?? 0) > 0) {
        return buildFitbPerBlankCorrectness(data, answer);
    }
    return undefined;
}
